import { useDispatch } from "react-redux";
import Slider from "../../../components/slider";
import styles from "./edit.module.scss";
import Button from "../../../components/button";
import _ from "lodash";
import { updateGroup } from "../../../redux/actions/groups";
import RichTextEditor from "src/components/richTextEditor";
import React, {ChangeEvent, useEffect, useState } from "react";
import cx from "classnames";
import Thumbnail from "src/components/thumbnail";
import EditThumbnailToolbar from "src/components/editThumbnail";
import { animated, useTransition } from '@react-spring/web';
import { MediaLibraryChooser } from "src/components/mediaLibrary";
import { MediaLibrary } from "src/types/mediaLibrary";
import useMeasure from "react-use-measure";
import { Crop } from "src/components/editThumbnail/crop";
import { useSelector } from "react-redux";
import { Group } from "src/types/groups";
import { Media, MediaFile } from "src/types/media";
import { nanoid } from '@reduxjs/toolkit';
import { invalidateMediaUpload, uploadMedia } from "src/redux/actions/media";
import { parseMediaMetadata } from "src/services/media.service";
import { IUseFetchProps, useFetch } from "src/components/hooks/useFetch";
import { useStreamsAdoption } from "src/redux/actions/adoption/streams";

interface EditGroupDetailsProps {
  show: boolean;
  group: Group;
  streamId: string;
  onClose: () => void;
}

export const EditGroupDetailsSlider: React.FC<EditGroupDetailsProps> = ({
  show, group, streamId, onClose
}) => {
  
  const { trackGroupEdited } = useStreamsAdoption();

  const [groupName, setGroupName] = useState(group.name);
  const [groupDescription, setGroupDescription] = useState(group.summary || "");
  const [editThumbail, setEditThumbnail] = useState(false);
  const [editAction, setEditAction] = useState("");
  const [selectedMedia, setSelectedMedia] = useState<Media | null>(null);
  const [loading, setLoading] = useState(false);
  const [cropData, setCropData] = useState({ x: 0, y: 0, width: 0, height: 0 });


  const updatingGroup = useSelector((state: any) => _.get(state, `group['${group.id}'].updation.updating`, null));
  const updatedGroup = useSelector((state: any) => _.get(state, `group['${group.id}'].updation.updated`, null));

  const uploading = useSelector((state: any) => _.get(state, `media.${selectedMedia?.id}.loading`, false));
  const uploaded = useSelector((state: any) => _.get(state, `media.${selectedMedia?.id}.loaded`, false));
  const uploadedBackground = useSelector((state: any) => _.get(state, `media.${selectedMedia?.id}.item`, null));

  const updateGroupProps: IUseFetchProps = {
    action: updateGroup,
    loading: updatingGroup,
    succeeded: updatedGroup,
    response: [],
    error: null
  };

  const { handleFetch: updateGroupRequest } = useFetch(updateGroupProps);

  const transitions = useTransition(show, {
    from: { transform: 'translateX(0%)' },
    enter: { transform: 'translateX(0%)' },
    leave: { transform: 'translateX(-100%)' },
  });

  const dispatch = useDispatch();
  const [headerRef, headerBounds] = useMeasure();

  useEffect(() => {
    if (!updatingGroup) {
      onClose();
      setSelectedMedia(null);
    }
  }, [updatingGroup])

  useEffect(() => {
    let thumbnail = selectedMedia;
    thumbnail = {
      ...thumbnail,
      id: thumbnail?.id || nanoid(6),
      thumbnail: group.icon?.thumbnail,
      full: group.icon?.full,
      key: group.icon?.key,
      type: "image"
    }

    setSelectedMedia(thumbnail)
  }, [show])

  useEffect(() => {
    if (uploaded) {
      var entity = {
        icon: {
          autoHeightEnabled: true,
          bannerHeight: 0,
          background: uploadedBackground.id,
          mediaType: "image",
          position: "center center",
        },
        id: group.id,
        iconSet: uploadedBackground ? true : false,
        name: groupName,
        nameSet: true,
        summary: groupDescription,
        summarySet: true
      }

      updateGroupRequest({ streamId: streamId, parent: entity.id, entity: entity }).then(() => {
        trackGroupEdited({ streamId: streamId, group: entity });
      });

      if (selectedMedia?.id) {
        dispatch(invalidateMediaUpload(selectedMedia.id));
      }
    }
  }, [uploaded])

  useEffect(() => {
    setGroupName(group.name);
  }, [group.id]);

  const renderGroupIcon = () => {
    return (
      <div className={cx(styles.groupIconContainer, {
      })}
        onClick={() => setEditThumbnail(true)}
        ref={headerRef}
      >
        <div className={cx(styles.groupIconWrapper)}> </div>
        <div className={cx(styles.radioWrapper, {
        })}>
          <i className="paperflite-edit"></i>
        </div>
        <div className={cx(styles.iconWrapper, {
        })}>

          <Thumbnail
            media={selectedMedia}
            className={cx(styles.thumbnail)}
            alt="group thumbnail"
            defaultImage="/images/assets/default_asset.jpg"
          />

        </div>
      </div>
    )
  }

  const handleChange = (e: any) => {
    const content = e.target.getContent();
    setGroupDescription(content);
  }

  const renderGroupDescription = () => {
    return (
      <RichTextEditor
        content={group?.summary || ""}
        onChange={handleChange}
        placeholder="Type here to add a description"
      />
    )
  }

  const handleCaptureFrame = (image) => {
    processImageDataToMedia(image);
  }

  const processImageDataToMedia = (imageData: string) => {
    fetch(imageData)
      .then((response) => {
        return response.blob();
      })
      .then(async (blob) => {
        const url = URL.createObjectURL(blob);
        const mediaFile = await parseMediaMetadata(new File([blob], 'thumbnail.png', { type: blob.type }));
        const thumbnailMedia = {
          id: nanoid(6),
          entityType: 'media-preview',
          type: mediaFile?.type,
          full: url,
          thumbnail: url,
          width: mediaFile?.width,
          height: mediaFile?.height,
          contentType: blob.type,
        } as MediaFile

        setSelectedMedia(thumbnailMedia);
      });
  }

  const processImageData = (url: any) => {

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return;
    }

    const image = new Image();
    image.crossOrigin = "anonymous";
    image.src = url;

    var dataUrl = "";

    image.onload = () => {
      if (cropData) {

        canvas.width = cropData.width;
        canvas.height = cropData.height;

        ctx.drawImage(image, cropData.x, cropData.y, cropData.width, cropData.height, 0, 0, cropData.width, cropData.height);

        dataUrl = canvas.toDataURL('image/jpeg', 0.85);
        processImageDataToMedia(dataUrl);
      }
    }
  };

  const handleConfirm = async () => {
    if (!editThumbail) {
      const isNewBannerSelected =
        selectedMedia?.full &&
        (!selectedMedia?.key || selectedMedia?.key !== group.icon?.key);

      if (isNewBannerSelected) {
        const mediaFile = selectedMedia as MediaFile;
        if (!selectedMedia.full) {
          throw new Error("Media URL is undefined");
        }
        const blob = await fetch(selectedMedia.full).then((r) => r.blob());
        const file = new File([blob], "thumbnail.png", {
          type: mediaFile.contentType || blob.type,
        });

        dispatch(
          uploadMedia({
            id: selectedMedia.id as string,
            media: {
              ...selectedMedia,
              file: file,
            } as MediaFile,
          }),
        );
      } else {
        const entity = {
          icon: {
            autoHeightEnabled: true,
            bannerHeight: 0,
          },
          id: group.id,
          iconSet: false,
          name: groupName,
          nameSet: true,
          summary: groupDescription,
          summarySet: true,
        };

        updateGroupRequest({ streamId, parent: entity.id, entity }).then(() => {
          trackGroupEdited({ streamId, group: entity });
        });
      }
    }

    if (editAction === "crop") {
      setEditAction("");
      processImageData(selectedMedia?.full);

      let thumbnail = selectedMedia;
      thumbnail = {
        ...thumbnail,
        id: thumbnail?.id || nanoid(6),
        type: thumbnail?.type as "video" | "image",
      }
      setSelectedMedia(thumbnail)
    } else {
      setEditAction("");
      setEditThumbnail(false);
    }
  }

  const handleCancel = () => {
    if (!editThumbail) {
      onClose();
    }

    setSelectedMedia({
      ...group.icon,
      id: group.icon?.id,
      type: "image"
    }); 

    if (editAction !== "crop") {
      setEditThumbnail(false);
    }

    setGroupDescription(group.summary || "");
    setGroupName(group.name);
    setEditAction("");
  }

  const handleClick = (action: string) => {
    setEditAction(action);
  }

  const handleThumbnailChange = (media: MediaLibrary) => {
    setCropData({ x: 0, y: 0, width: media.width ?? 0, height: media.height ?? 0 });

    if (!media) {
      return;
    }

    const imageUrl = media.imageUrl;
    if (!imageUrl) {
      return;
    }

    fetch(imageUrl)
      .then((response) => {
        return response.blob();
      })
      .then(blob => {
        const url = URL.createObjectURL(blob);

        const thumbnailMedia = {
          id: nanoid(6),
          entityType: 'media-preview',
          type: media.mediaType,
          full: url,
          thumbnail: url,
          width: media.width,
          height: media.height,
          contentType: blob.type,
        } as MediaFile

        setSelectedMedia(thumbnailMedia);

      }).catch(error => {
        console.error(error);
      });

    setEditAction("");
  }

  const handleCroppedThumbnail = (value) => {
    setCropData(value);
  }

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const thumbnailMedia = await parseMediaMetadata(file);
    if (!thumbnailMedia) return;
    processImageDataToMedia(thumbnailMedia?.full)
    setEditAction("");
    setEditThumbnail(true);
  };
  return (
    <div>
      {transitions((style, item) =>
        item ? (
          <animated.div style={style}>
            <Slider.Dialog
              className={styles.editGroupDetailsContainer}
              width={editAction === "edit" ? `33.25rem` : `23.75rem`}
              show={show}
              onClose={onClose}
            >
              <Slider.Header
                title={
                  editAction === "edit" ? (
                    <div className={styles.editHeader}>
                      <div>
                        <i
                          className={cx(
                            "paperflite-left-arrow",
                            styles.backIcon,
                          )}
                          onClick={() => setEditAction("")}
                        ></i>
                        <span className={styles.sliderTitle}>pick your cover image</span>
                      </div>
                      <button
                        className={cx(styles.fileUpload)}
                        disabled={false}
                      >
                        <i className={cx(styles.icon, "paperflite-upload")}></i>
                        <span className={styles.title}>upload</span>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleFileChange}
                        />
                      </button>
                    </div>
                  ) : (
                    "manage group"
                  )
                }
                message={
                  editAction === "edit"
                    ? ""
                    : "Customize away! Just don’t turn it into an art project."
                }
              ></Slider.Header>
              <Slider.Body>
                {!editThumbail && (
                  <div className={styles.details}>
                    <input
                      type="text"
                      value={groupName}
                      placeholder="Provide group name"
                      onChange={(e) => setGroupName(e.target.value)} 
                      onBlur={() => {
                        if (groupName.trim() === "") {
                        setGroupName(group.name);
                        }
                      }}
                      />
                      {renderGroupIcon()}
                      {renderGroupDescription()}
                    </div>
                  )}

                  {editAction === "" && editThumbail &&(

                    <div className={styles.body}>
                      <Thumbnail
                        media={selectedMedia}
                        className={styles.group}
                        alt="thumbnail"
                        defaultImage="/images/assets/default_asset.jpg"
                      />

                      <EditThumbnailToolbar
                        show={editThumbail}
                        handleClick={(action) => handleClick(action)} />
                    </div>
                  )}

                  {editAction === "edit" && (
                    <div>
                      <MediaLibraryChooser
                        entityType="group"
                        onChange={handleThumbnailChange}
                        columns={4}
                        handleCaptureFrame={handleCaptureFrame}
                      />
                    </div>
                  )}

                  {editAction === "crop" && (
                    <Crop enabled={true}
                      icon={selectedMedia?.full}
                      loading={loading}
                      onCrop={handleCroppedThumbnail}
                      headerDimension={{
                        height: headerBounds.height,
                        width: headerBounds.width,
                      }}
                      cropperDimensions={{
                        width: '15rem',
                        height: '19.375rem',
                      }}
                    />
                  )}
                </Slider.Body>

                {(editAction === "" || editAction === "crop") && (
                  <Slider.Actions>
                    <Button icon="paperflite-tick"
                      text={uploading || updatingGroup ? 'Updating...' : 'Confirm'}
                      variant='primary'
                      disabled={uploading || updatingGroup}
                      onClick={handleConfirm}
                    />
                    <Button text="Cancel"
                      variant='secondary'
                      disabled={updatingGroup}
                      onClick={handleCancel}
                    />
                  </Slider.Actions>)}
              </Slider.Dialog>
            </animated.div>
          ) : null)
      }

    </div>
  );
}